module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAMAAABhEH5lAAAAAXNSR0IArs4c6QAAAGBQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/zIyAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/zMzo8zYTwAAAB90Uk5TAAMJGiEuPFBRUlhfdH+DkZ6htre/ydPc5+jp6u/5/gB6ShAAAAB6SURBVBjTpdBHDoQwDEDRD6GEEnooofj+t5wVAaRhxV8+S7ZkeC0Zx+QBQXXU9VEFl0R21aBXG51SbIMCUMNWABC2e3kOy70NgWaKrxXx1ABLfj+UL4BL75Q6wGlAREQE0J6MMcaYB/m+UW8z7ctsD6hudr65U/9e9wOLigetAqMW6QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ShouH.png
// module id = cALY
// module chunks = 7